<template>
  <div>
    <b-modal
        id="custom-asin-modal"
        centered
        size="md"
        :title="$t('pages.review.custom_asin.title')"
        title-class="font-18"
    >
      <b-row>
        <b-col class="text-end">
          <remaining :total="total" :used="selectedAsins.length + used"></remaining>
        </b-col>
        <b-col sm="12">
          <b-form-group
              class="mb-2"
              :label="$t('pages.review.custom_asin.marketplace')"
              label-for="marketplace"
              label-cols="12"
              :description="$t('pages.review.custom_asin.marketplace_description')"
          >
            <market-place-component id="marketplace"
                                    v-model="selectedMarketplace"
                                    :invalid="submitted && $v.selectedMarketplace.$error"
                                    :multiple="false"
                                    :all="true"
            />
          </b-form-group>
          <div
              v-if="submitted && !$v.selectedMarketplace.required"
              class="d-block invalid-feedback"
          >
            {{ $t('pages.review.custom_asin.validations.marketplace_required') }}
          </div>
        </b-col>
        <b-col sm="12">
          <b-form-group
              class="mb-3"
              :label="$t('pages.review.custom_asin.asins')"
              label-for="custom-asin"
              label-cols="12"
          >
            <b-form-tags
                class="form-control"
                id="custom-asin"
                tag-variant="primary"
                tag-pills
                :duplicateTagText="$t('pages.review.custom_asin.duplicate')"
                :invalidTagText="$t('pages.review.custom_asin.invalid')"
                :limitTagsText="$t('pages.review.custom_asin.limit')"
                v-model="selectedAsins"
                separator=" ,;"
                :tag-validator="tagValidator"
                :placeholder="$t('pages.review.custom_asin.tag_placeholder')"
                no-add-on-enter
                :state="submitted ? !$v.selectedAsins.$error : null"
                :limit="quota ? quota.remaining : 0"
            >
            </b-form-tags>
            <div
                v-if="submitted && !$v.selectedAsins.required"
                class="d-flex invalid-feedback"
            >
              {{ $t('pages.review.custom_asin.min_tag', {min: 1}) }}
            </div>
            <div
                v-if="submitted && !$v.selectedAsins.maxLength"
                class="d-flex invalid-feedback"
            >
              {{ $t('pages.review.custom_asin.max_tag', {max: $v.selectedAsins.$params.maxLength.max}) }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <b-button variant="danger" @click="cancel()">
          {{ $t('pages.review.custom_asin.cancel') }}
        </b-button>
        <b-btn variant="primary" :disabled="loading" @click="handleOk()">
          <b-spinner v-if="loading" small></b-spinner>
          {{ $t('pages.review.custom_asin.track') }}
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>

<script>

import MarketPlaceComponent from "../../../components/widgets/MarketPlaceComponent";
import ProductService from "../../../Services/Api/ProductService";
import QuotaMixin from "../../../mixins/QuotaMixin";
import Remaining from "../../../components/Remaining";
import {maxLength, required} from "vuelidate/lib/validators";

export default {
  name: "CustomAsinTrack",
  components: {Remaining, MarketPlaceComponent},
  mixins: [QuotaMixin],
  props: ['availableLangs'],
  data() {
    return {
      selectedAsins: [],
      selectedMarketplace: null,
      loading: false,
      quotaType: 'product_track',
      submitted: false,
      noNeedQuota: true
    }
  },
  validations: {
    selectedMarketplace: {
      required
    },
    selectedAsins: {
      required,
      maxLength: maxLength(200),
      $each: {
        required
      }
    }
  },
  methods: {
    async handleOk() {
      this.submitted = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      } else {
        const payload = {products: []}
        this.selectedAsins.forEach(item => {
          const product = {
            'marketplace_id': this.selectedMarketplace.marketplace_id,
            'asin': item
          }

          payload.products.push(product)
        })

        this.loading = true
        await ProductService.store({
          payload
        }).then(() => {
          this.$bvModal.hide('custom-asin-modal')
          this.$emit('track')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    tagValidator(tag) {
      const regex = /[A-Z0-9]{10}/.exec(tag)
      return regex && tag.length <= 10
    }
  },
}
</script>

<style scoped>
/deep/ .b-form-tag > button.b-form-tag-remove {
  color: inherit;
  font-size: 135%;
  line-height: 1;
  float: none;
  margin-left: 0.25rem;
}

/deep/ .b-form-tag > button.b-form-tag-remove:hover {
  background-color: rgba(255, 255, 255, 0.58);
}

/deep/ button.close {
  padding: 0 2px 0 2px;
  background-color: transparent;
  border: 0;
  border-radius: 1px;
}

</style>